



























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/family/edit/EditComposition.vue'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily';
import { toStringDictionary } from '@/utils/groupBy';
import moment from 'moment';
import commande from '@/api/commande';

@Component({
  name: 'ReadCommandes',    
   props: {
    family:{      
      default:getDefaultAloFamily()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadCommandes extends Vue {
  private family!:AloFamily
  private loading!:boolean

 
  private headers = [        
    { text: 'Id', value: 'id', width:70},       
    { text: 'Date', value: 'cmdDatValidation', width:150  },
    { text: 'Status', value: 'cmdStatus', width:110 },       
    { text: 'Famille', value: 'libelle'},       
    { text: 'Ville', value: 'address.libelle', width:130 },
    { text: 'Total', value: 'cmdTotal', width:100, align: 'end' }
  ]

  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.family) }
}
